<template>
    <v-dialog v-model="dialog" max-width="560">
        <v-card>
            <v-card-title class="subtitle-1">핀상태</v-card-title>
            <v-data-table :headers="senderHeaders" :items="pin" class="elevation-1" hide-default-footer >
            </v-data-table>   
            <v-data-table :headers="receiverHeaders" :items="pin" class="elevation-1" hide-default-footer >
                <template v-slot:item.createdAt="{item}">
                    <span v-if="item.createdAt">{{$dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}}</span>
                    <span v-else>-</span>
                </template>
				<template v-slot:item.payedAt="{item}">
                    <span v-if="item.payedAt">{{$dayjs(item.payedAt).format("YYYY-MM-DD HH:mm:ss")}}</span>
                    <span v-else>-</span>
                </template>
            </v-data-table>           
            <v-card-actions>
                <v-spacer/>
                <v-btn text color="grey" @click="close">닫기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api"

export default {
	data() {
		return {
			dialog: false,
			pin: [],

			senderHeaders: [
                { text: '핀번호', value: 'pno', },
                { text: '액면가', value: 'faceamt' },
                { text: '핀상태', value: 'statusMessage' },
                { text: '발행처', value: 'cp.name' },
                { text: '구매자', value: 'name' },
            ],
            receiverHeaders: [
                { text: '발행일자', value: 'createdAt', width: '50%', align: 'center'},
                { text: '사용일자', value: 'payedAt' },
            ],
		}
	},
	methods: {
		async open(cash) {
			this.pin = [];
			let { pin } = await api.console.pins.get({
				params: { pno: cash.pno }
			});
			this.pin.push(pin);
			this.dialog = true;
		},
		close() {
			this.dialog = false;
		}
	}
}
</script>

<style>

</style>